import { useState } from "react";
import Thyroid_ultra_sound from "../../Forms/applications/thyroidUltraSound";
import ObdominalUltrasoundModal from "../../Forms/applications/abdominalultrasound";
import AbdominalDopplerModal from "../../Forms/applications/abdominalDoppler";
import AortaUltraSound from "../../Forms/applications/aortaUltraSound";
import BladderUltraSound from "../../Forms/applications/bladderultrasound";
import BreastUltraSound from "../../Forms/applications/breastultrasound";
import RenelDoplerUltraSound from "../../Forms/applications/renaldoppler";
import LowerExtremelyVennousDoppler from "../../Forms/applications/lowerExtremelyVenous";
import TestucularUltraSound from "../../Forms/applications/testicularultrasound";
import ProstateTransAbdorminal from "../../Forms/applications/prostateTransAbdorminal";
import OrthoultraSound from "../../Forms/applications/orthoultrasound";
import Estim from "../../Forms/applications/estim";
import Echo from "../../Forms/applications/echo";
import Venous from "../../Forms/applications/venous";
import Carotid from "../../Forms/applications/carotid";
import Arterial from "../../Forms/applications/arterial";
import PelvicUltrasoundForm from "../../Forms/applications/PelvicUltrasound";

const ImagingPopup = ({ data, setImagingModal }) => {
  const [thyroidModal, setThyroidModal] = useState(false);
  const [abdominalModal, setAbdominalModal] = useState(false);
  const [dopplerModal, setDopplerModal] = useState(false);
  const [aortaSoundModal, setAortaSoundModal] = useState(false);
  const [bladderultrasoundmodal, setBladderUltrasoundModal] = useState(false);
  const [breastultrasoundmodal, setBreastUltrasoundModal] = useState(false);
  const [RenalDoplerModal, setRenalDoplerModal] = useState(false);
  const [
    lowerextremelyvenousdopplerModal,
    setLowerExtremelyVenousDopplerModal,
  ] = useState(false);
  const [testicularultrasoundmodal, setTesticularUltrasoundmodal] =
    useState(false);
  const [ProstateTransAbdorminalmodal, setProstateTransAbdorminalModal] =
    useState(false);
  const [OrthoultraSoundModal, setOrthoUltraSound1modal] = useState(false);
  const [PelvicUltrasoundModal, setPelvicUltraSoundModal] = useState(false);
  const [EstimModal, setEstimModal] = useState(false);
  const [EchoModal, setEchoModal] = useState(false);
  const [VenousModal, setVenousModal] = useState(false);
  const [CarotidModal, setCarotidModal] = useState(false);
  const [ArterialModal, setArterialModal] = useState(false);

  const forms = [
    "THYROID ULTRASOUND",
    "ABDOMINAL ULTRASOUND",
    "ABDOMINAL ULTRASOUND DOPPLER",
    "AORTA ULTRASOUND",
    "BLADDER ULTRASOUND PRELIMINARY",
    "BREAST ULTRASOUND",
    "RENAL DOPPLER ULTRASOUND",
    "LOWER EXTREMELY VENOUS DOPPLER",
    "TESTICULAR ULTRASOUND",
    "PROSTATE TRANSABDOMINAL IMAGING",
    "ORTHO ULTRASOUND",
    "ESTIM",
    "ECHO",
    "VENOUS",
    "CAROTID",
    "ARTERIAL",
  ];
  if (data.gender === "F") {
    forms.splice(2, 0, "PELVIC ULTRASOUND"); // insert at index 2 (or any specific index)
    const testicularIndex = forms.indexOf("TESTICULAR ULTRASOUND");
    if (testicularIndex !== -1) {
      forms.splice(testicularIndex, 1);
    }
  }
  const openModal = (type) => {
    switch (type) {
      case "THYROID ULTRASOUND":
        setThyroidModal(true);
        break;
      case "ABDOMINAL ULTRASOUND":
        setAbdominalModal(true);
        break;
      case "ABDOMINAL ULTRASOUND DOPPLER":
        setDopplerModal(true);
        break;
      case "AORTA ULTRASOUND":
        setAortaSoundModal(true);
        break;
      case "BLADDER ULTRASOUND PRELIMINARY":
        setBladderUltrasoundModal(true);
        break;
      case "BREAST ULTRASOUND":
        setBreastUltrasoundModal(true);
        break;
      case "RENAL DOPPLER ULTRASOUND":
        setRenalDoplerModal(true);
        break;
      case "LOWER EXTREMELY VENOUS DOPPLER":
        setLowerExtremelyVenousDopplerModal(true);
        break;
      case "TESTICULAR ULTRASOUND":
        setTesticularUltrasoundmodal(true);
        break;
      case "PROSTATE TRANSABDOMINAL IMAGING":
        setProstateTransAbdorminalModal(true);
        break;
      case "ORTHO ULTRASOUND":
        setOrthoUltraSound1modal(true);
        break;
      case "ESTIM":
        setEstimModal(true);
        break;
      case "ECHO":
        setEchoModal(true);
        break;
      case "VENOUS":
        setVenousModal(true);
        break;
      case "CAROTID":
        setCarotidModal(true);
        break;
      case "ARTERIAL":
        setArterialModal(true);
        break;
      case "PELVIC ULTRASOUND":
        setPelvicUltraSoundModal(true);
        break;
      default:
        break;
    }
  };

  return (
    <div className="flex justify-center items-center">
      <div className="relative w-full max-w-[900px] rounded-2xl border border-[#F3F4F6] bg-white shadow-[0_8px_30px_rgba(0,0,0,0.08)] p-8 transition-all duration-300">
        {/* Header */}
        <h2 className="text-[24px] font-bold text-[#111827] text-start font-font1">
          Select Type of Worksheet
        </h2>
        <p className="text-sm text-[#6B7280] font-font1 text-start mt-1 mb-6">
          Choose the appropriate worksheet type to continue
        </p>

        {/* Close Button */}
        <button
          onClick={() => setImagingModal(false)}
          className="absolute top-4 right-5 text-gray-500 hover:text-red-600 text-[22px] font-bold transition-colors focus:outline-none"
        >
          &times;
        </button>

        {/* Buttons Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-4">
          {forms.map((type) => (
            <button
              key={type}
              onClick={() => openModal(type)}
              className="w-full text-[#E17954] text-center font-font1 font-medium text-[14px] px-5 py-3 rounded-xl bg-gradient-to-r from-[#E179540D] to-[#E179541A] hover:bg-[#E179541A] transition-all duration-200"
            >
              {type}
            </button>
          ))}
        </div>
      </div>

      {/* Modals */}
      {thyroidModal && (
        <Thyroid_ultra_sound
          data={data}
          ismodal={thyroidModal}
          setIsmodal={setThyroidModal}
        />
      )}
      {abdominalModal && (
        <ObdominalUltrasoundModal
          data={data}
          ismodal={abdominalModal}
          setIsmodal={setAbdominalModal}
        />
      )}
      {dopplerModal && (
        <AbdominalDopplerModal
          data={data}
          ismodal={dopplerModal}
          setIsmodal={setDopplerModal}
        />
      )}
      {aortaSoundModal && (
        <AortaUltraSound
          data={data}
          ismodal={aortaSoundModal}
          setIsmodal={setAortaSoundModal}
        />
      )}
      {bladderultrasoundmodal && (
        <BladderUltraSound
          data={data}
          ismodal={bladderultrasoundmodal}
          setIsmodal={setBladderUltrasoundModal}
        />
      )}
      {breastultrasoundmodal && (
        <BreastUltraSound
          data={data}
          ismodal={breastultrasoundmodal}
          setIsmodal={setBreastUltrasoundModal}
        />
      )}
      {RenalDoplerModal && (
        <RenelDoplerUltraSound
          data={data}
          ismodal={RenalDoplerModal}
          setIsmodal={setRenalDoplerModal}
        />
      )}
      {lowerextremelyvenousdopplerModal && (
        <LowerExtremelyVennousDoppler
          data={data}
          ismodal={lowerextremelyvenousdopplerModal}
          setIsmodal={setLowerExtremelyVenousDopplerModal}
        />
      )}
      {testicularultrasoundmodal && (
        <TestucularUltraSound
          data={data}
          ismodal={testicularultrasoundmodal}
          setIsmodal={setTesticularUltrasoundmodal}
        />
      )}
      {ProstateTransAbdorminalmodal && (
        <ProstateTransAbdorminal
          data={data}
          ismodal={ProstateTransAbdorminalmodal}
          setIsmodal={setProstateTransAbdorminalModal}
        />
      )}
      {OrthoultraSoundModal && (
        <OrthoultraSound
          data={data}
          ismodal={OrthoultraSoundModal}
          setIsmodal={setOrthoUltraSound1modal}
        />
      )}
      {EstimModal && (
        <Estim data={data} ismodal={EstimModal} setIsmodal={setEstimModal} />
      )}
      {EchoModal && (
        <Echo data={data} ismodal={EchoModal} setIsmodal={setEchoModal} />
      )}
      {VenousModal && (
        <Venous data={data} ismodal={VenousModal} setIsmodal={setVenousModal} />
      )}
      {CarotidModal && (
        <Carotid data={data} ismodal={CarotidModal} setIsmodal={setCarotidModal} />
      )}
      {ArterialModal && (
        <Arterial data={data} ismodal={ArterialModal} setIsmodal={setArterialModal} />
      )}
      {PelvicUltrasoundModal && (
        <PelvicUltrasoundForm
          data={data}
          ismodal={PelvicUltrasoundModal}
          setIsmodal={setPelvicUltraSoundModal}
        />
      )}
    </div>
  );
};

export default ImagingPopup;
